module.exports = "https://cdn.redage.net/src/views/casino/jacpot/logo.svg";